export class BuildDetails {
  buildNumber: string;
  buildDh?: string;
}
